export default __webpack_public_path__ + "static/media/rob.697aab32.jpg";